enum ThemeEnum {
	Light,
	Dark,
	System,
}

export default ThemeEnum;
